export const CALLING_ROUTE = "/calling";